<template lang="pug">
.charts
    .barchart(ref="barchart", v-show="!isOptionEmpty")
    .emptychart(v-show="isOptionEmpty")
    .loadingchart(v-show="loading")
</template>

<script>
/* global _, echarts */
import Vue from 'vue'
import resizeMixin from './resize.mixin.js'
import { PIE_COLORS } from './options.js'
const toPercent = Vue.filter('percent')

export default {
  mixins: [resizeMixin],
  props: {
    comp: {
      type: Boolean,
      default: false
    },
    hirizonal: {
      type: Boolean,
      defalse: false
    },
    initXAxis: Array,
    legend: Array,
    series: Array,
    color: {
      type: [String, Array],
      // mutil
      default: 'single'
    },
    dir: {
      type: String,
      default: 'horizontal'
    },
    valueAxis: {
      type: Array,
      default: () => []
    },
    tooltip: {
      type: [String, Function]
    },
    height: {
      type: [Number, String],
      default: 300
    },
    loading: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      curTotal: 0,
      compTotal: 0,
      total: 0,
      chart: null
    }
  },
  computed: {
    isOptionEmpty: function () {
      return _.isEmpty(this.series) || (!_.isEmpty(this.series) && this.allSeriesEmpty(this.series))
    },
    barColor () {
      if (_.isArray(this.color)) {
        return (item) => this.color[item.dataIndex] || '#A3B3BF'
      } else if (this.color === 'multi') { return (item) => PIE_COLORS[item.dataIndex] }
      if (/^#([a-fA-F0-9]{3}){1,2}$/.test(this.color)) return this.color
      return '#73ACE6'
    },

    barSeries () {
      let series = []
      if (this.comp) {
        series = this.series
        this.curTotal = this.series[0].data.reduce((result, i) => {
          result += i.value
          return result
        }, 0)
        this.compTotal = this.series[1].data.reduce((result, i) => {
          result += i.value
          return result
        }, 0)
        series.map(item => {
          item.barWidth = 24
        })
        series[0].name = '本期'
        series[1].name = '对比时段'
      } else if (this.hirizonal) {
        series = [
          {
            type: 'bar',
            barWidth: 35,
            data: this.series.map(
              (i) => {
                const obj = {
                  'value': i.value,
                  'itemStyle': i.itemStyle
                }
                return obj
              }
            ),
            label: {
              normal: {
                show: true,
                position: 'insideTopRight'
              }
            }
          }
        ]
      } else {
        series = [
          {
            type: 'bar',
            barMaxWidth: 36,
            barMinHeight: 0,
            data: this.series.map(i => i.value),
            itemStyle: {
              normal: { color: this.barColor }
            },
            name: this.series.length && this.series[0].legend ? this.series[0].legend : '本期',
            animationDelay: function (idx) {
              return idx * 10
            }
          }
        ]

        this.total = this.series.reduce((ac, i) => {
          ac += i.value
          return ac
        }, 0)
      }
      return series
    }
  },
  methods: {
    initChart () {
      const dom = this.$refs.barchart
      if (dom) {
        this.chart = echarts.init(dom, null, {height: this.height})
      }
    },
    allSeriesEmpty (series) {
      let i = 0
      const l = series.length
      while (i < l) {
        if (series[i].data === void (0) || (series[i].data !== void (0) && !_.isEmpty(this.series[i].data))) { return false } else if (series[i].data !== void (0) && _.isEmpty(this.series[i].data)) { i++ }
      }
      return true
    },
    draw () {
      if (!this.chart && !this.isOptionEmpty) {
        this.initChart()
      }
      if (this.chart) {
        const dir = this.dir === 'vertical' ? 'x' : 'y'
        const valueAxisItem = dir === 'x' ? 'yAxis' : 'xAxis'
        const categoryAxis = `${dir}Axis`
        const self = this
        const option = {
          tooltip: {
            trigger: 'item',
            showDelay: 120,
            formatter: this.tooltip || function (param) {
              let total = 0
              if (self.comp) {
                total = param.seriesName === '对比时段' ? self.compTotal : self.curTotal
              } else {
                total = self.total
              }
              const { name, value } = param
              const percent = total === 0 ? '9%' : toPercent(value / total)
              if (self.hirizonal) {
                return `${name}</br>数值：${value}`
              }
              return `${name}</br>百分比：${percent}`
            }
          },
          grid: {
            top: '60',
            left: '3%',
            right: '4%',
            bottom: '15%',
            containLabel: true
          },
          legend: {
            data: this.legend,
            align: 'left',
            left: 15,
            top: 15,
            itemWidth: 12,
            itemHeight: 12,
            itemGap: 15,
            textStyle: {color: '#999'}
          },
          color: this.color,
          [categoryAxis]: self.comp ? {
            data: this.initXAxis
          } : {
            data: this.series.map(i => i.name),
            silent: false,
            splitLine: {
              show: false
            },
            axisTick: {
              alignWithLabel: true
            }
          },
          [valueAxisItem]: this.valueAxis.length ? this.valueAxis : {
            type: 'value'
          },
          series: self.barSeries,
          animationEasing: 'elasticOut',
          animationDelayUpdate: function (idx) {
            return idx * 5
          }
        }
        // notMerge是否不跟之前设置的option进行合并，默认为false，即合并
        if (typeof this.tooltip === 'function') {
          option.tooltip.formatter = (params) => {
            return this.tooltip(params)
          }
        }
        this.chart.setOption(option, {
          notMerge: true
        })
      }
    }
  },
  updated () {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.draw(), 150)
  },
  mounted () {
    this.draw()
  },
  destroyed () {
    this.chart = null
    clearTimeout(this.timer)
  }
}
</script>



// WEBPACK FOOTER //
// barChart.vue?4b45c396